import { createContext, useContext } from 'react';
import type { IZendeskContext } from './Zendesk';

export const ZendeskContext = createContext<IZendeskContext>({
    openWebWidget: () => {},
    closeWebWidget: () => {},
    setOnWidgetCloseCallback: () => {},
    isWidgetOpen: false,
});
export const useZendeskContext = () => {
    const context = useContext(ZendeskContext);
    if (!context) {
        throw new Error('ZendeskContext cannot be used outside the ZendeskContext provider')
    }
    return context;
}